// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hide_wrapper-module__hide--ruT3M{position:relative}.hide_wrapper-module__hidden--3UDCf{width:100%;height:100%;position:absolute;top:0;left:0;z-index:5;background-color:rgba(0,0,0,0.4);-webkit-border-radius:3px;-moz-border-radius:3px;border-radius:3px}.hide_wrapper-module__locked--3NqTe{position:absolute;top:-webkit-calc(50% - 22.5px);top:-moz-calc(50% - 22.5px);top:calc(50% - 22.5px);left:-webkit-calc(50% - 22.5px);left:-moz-calc(50% - 22.5px);left:calc(50% - 22.5px);z-index:10;font-size:45px;color:#fff;pointer-events:none}\n", ""]);
// Exports
exports.locals = {
	"hide": "hide_wrapper-module__hide--ruT3M",
	"hidden": "hide_wrapper-module__hidden--3UDCf",
	"locked": "hide_wrapper-module__locked--3NqTe"
};
module.exports = exports;
